import React from 'react';
import { AppConfigSection } from '../sections';

export const AppConfigTab: React.FC = () => {
  return <AppConfigSection />;
};